import { render, staticRenderFns } from "./S3FileGenerator.vue?vue&type=template&id=04d236c2&"
import script from "./S3FileGenerator.vue?vue&type=script&lang=js&"
export * from "./S3FileGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports